<template>
    <div>
        <b-modal
            :active.sync="showDeleteModal"
            :can-cancel="['escape', 'outside']"
            trap-focus
            container="body"
            class="has-text-centered"
        >
            <div class="modal-body">
                <span
                    class="is-size-4 has-text-danger has-text-weight-bold is-uppercase"
                >
                    {{ $t("manageAccount.deleteaccForm.confirm") }}
                </span>
                <ValidationObserver v-slot="{ handleSubmit, invalid }">
                    <form
                        class="form"
                        @submit.prevent="handleSubmit(console.log('?'))"
                    >
                        <div
                            class="is-size-6 mb-2 has-text-danger has-text-weight-bold"
                        >
                            {{ $t("manageAccount.deleteaccForm.description") }}
                        </div>

                        <!-- <ValidationProvider
                            rules="required|min:2|max:50"
                            v-slot="{ errors }"
                            class="form__element"
                        >
                            <b-field
                                :message="errors[0]"
                                class="is-custom-field"
                                :label="
                                    $t(
                                        'manageAccount.deleteaccForm.password.label'
                                    )
                                "
                            >
                                <b-input
                                    :disabled="isLoadingData || disabled"
                                    type="password"
                                    class="is-custom-input"
                                    autocomplete="false"
                                    :placeholder="
                                        $t(
                                            'manageAccount.deleteaccForm.password.placeholder'
                                        )
                                    "
                                    v-model="userinput.password"
                                />
                            </b-field>
                        </ValidationProvider> -->

                        <div class="field is-grouped">
                            <div class="control">
                                <button
                                    :disabled="
                                        isLoadingData || disabled || invalid
                                    "
                                    class="button is-danger"
                                    type="submit"
                                >
                                    <span class="m-0 p-0">
                                        {{
                                            $t(
                                                "manageAccount.deleteaccForm.submit"
                                            )
                                        }}</span
                                    >
                                </button>

                                <button
                                    :disabled="
                                        isLoadingData || disabled || invalid
                                    "
                                    class="button is-secondary-alt"
                                    type="reset"
                                    @click.prevent="resetAndClose"
                                >
                                    <span class="m-0 p-0">
                                        {{
                                            $t(
                                                "manageAccount.deleteaccForm.cancel"
                                            )
                                        }}</span
                                    >
                                </button>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </b-modal>

        <button
            :disabled="isLoadingData || disabled"
            class="button is-danger"
            @click.prevent="showDeleteModal = true"
        >
            <span class="m-0 p-0">
                {{ $t("manageAccount.deleteaccForm.submit") }}</span
            >
        </button>
    </div>
</template>
<style lang="scss" scoped>
.grid {
    margin: 0;
    padding: 0;
}
.disabled {
    opacity: 0.15;
    pointer-events: none;
}

.is-custom-input {
    background: var(--bg);
    // input[disabled] {
    //     background-color: var(--bg) !important;
    //     background: var(--bg) !important;
    //     color: var(--color-primary-alt) !important;
    // }
}
.flex-start {
    display: flex;
    flex-direction: row;
    justify-content: flex;
    align-items: center;
}

.modal-background {
    position: fixed;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 1000;
}

.modal-body {
    @media screen and (max-width: 768px) {
        width: 90vw;
    }
    background: rgba(var(--bg-rgba), 0.8);
    backdrop-filter: blur(2rem);
    border-radius: var(--radius-sm);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: auto;
    max-width: 450px;
    text-align: left;
}

.discover-btn {
    align-self: flex-end;
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;
    background: var(--color-primary-alt);
    color: white !important;
}
.card-content {
    padding: 0;
    height: 100%;
}
.content {
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    // border: 1px solid var(--color-primary-alt);
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
}
.rel {
    background: var(--bg-secondary);

    position: relative;
    height: 100%;
    width: 100%;
}

.full-carousel {
    overflow: hidden;
    // border-radius: 1rem;
    max-height: 450px;
    margin: 0;
    width: 100%;
    height: 100%;
}
.bg-image {
    border-radius: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    // max-height: 450px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    // border: 1px solid red;
    img {
        filter: blur(5px) brightness(0.7);
        transform: scale(1.1);
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }
}

.text-overlay {
    // pointer-events: none;
    position: relative;
    padding: 1rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: white;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    // background: rgba(var(--bg-rgba), 0.45);
    z-index: 100;
}
.card-collapse {
    .card-collapse-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 1rem;
        margin-bottom: 0;
    }
    width: 100%;
    background: var(--bg);
}
.wrapper-box {
    // border: 1px solid var(--color-danger);
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.submit-btn {
    background: rgba(var(--bg-rgba), 0.3) !important;
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 0 1.5rem;
    margin: 1rem 0 0 0 !important;
    align-items: center;
    .icon {
        font-size: 2rem !important;
    }
}
.error_field {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-danger);
    /* margin-bottom: 0.35rem; */
}
.info-box {
    padding: 1.5rem 1rem 0 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.result-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    background: var(--bg);
    // border-radius: 1rem;
    &.is-errored {
        background: rgba(var(--color-danger-rgba), 0.35) 0%;
    }
}
.result_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    text-transform: capitalize;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}

.query_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.success_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    // color: var(--color-primary);
    color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.result > .result_field {
    text-align: center;
    font-weight: 300;
}
.result {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
}
</style>
<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, oneOf, required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Campo richiesto",
});

extend("min", {
    ...min,
    message: "Minimo caratteri: {length}",
});

extend("max", {
    ...max,
    message: "Massimo caratteri: {length}",
});

extend("email", {
    ...email,
    message: "Indirizzo e-mail non valido.",
});

extend("oneOf", {
    ...oneOf,
    message: "Paese non valido",
});
export default {
    data() {
        return {
            showDeleteModal: false,
            isLoadingData: false,
            size: 0,
            open: false,
            password: "",
            email: "",
            isErrored: false,
            userinput: {
                email: "",
                password: "",
                newpassword: "",
                newpasswordConfirm: "",
            },
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        events: {
            type: Array,
            default: () => [],
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    // mounted() {
    //     this.$nextTick(function () {
    //         this.onResize();
    //     });

    //     window.addEventListener("resize", this.onResize);
    // },
    // beforeDestroy() {
    //     window.removeEventListener("resize", this.onResize);
    // },
    methods: {
        resetAndClose() {
            this.userinput = {};
            this.showDeleteModal = false;
        },
        // getScreenSize() {
        //     const width =
        //         window.innerWidth ||
        //         document.documentElement.clientWidth ||
        //         document.body.clientWidth;
        //     return width;
        // },
        // onResize() {
        //     this.size = this.getScreenSize();
        // },
    },
};
</script>
